import perfilTributarioLista from "@/modules/PerfilTributario/pages/Index";
import perfilTributarioNova from "@/modules/PerfilTributario/pages/Create";
import perfilTributarioEditar from "@/modules/PerfilTributario/pages/Update";

export default [
  {
    name: "perfilTributarioLista",
    path: "/perfilTributario",
    component: perfilTributarioLista,
    meta: { title: "Perfil Tributário" },
  },
  {
    name: "perfilTributarioNova",
    path: "/perfilTributario/nova",
    component: perfilTributarioNova,
    meta: { title: "Novo Perfil Tributário" },
  },
  {
    name: "perfilTributarioEditar",
    path: "/perfilTributario/:id/editar",
    component: perfilTributarioEditar,
    meta: { title: "Editar Perfil Tributário" },
  }
];
